module.exports = __webpack_public_path__ + "static/media/Notice_VideoMonitoring.b2eda9e6.png";